// extracted by mini-css-extract-plugin
export default {"wrapper":"Ln-z","response":"Mn-z","error":"Nn-z","disabled":"On-z","buttons":"Pn-z","feedbackQuestionSection":"Qn-z","yesNoWrapper":"Rn-z"};